import React, {useEffect, useState} from "react";
import { Modal } from '../../common/Modal';

const LoginNotAuthorized = ({ visible, actions }) => {

    const onCloseHandler = () => {
        actions.close();
    }

    return (
        <Modal
            open={visible}
            type={Modal.MODAL_TYPES.warning}
            canBeDismissed={true}
            className="authentication"
            onClose={onCloseHandler}
        >
            <div className="modal-box authentication">
                <div className="modal-box--content">
                    <span className="subtitle">
                        Dispositivo no autorizado
                    </span>
                    <p className="modal-box--data mt-2 mb-4">
                        No podés ingresar a esta cuenta
                    </p>
                    <button className="cta-button w-100" onClick={actions.close}>Volver</button>
                </div>
            </div>
        </Modal>
    )
}

export default LoginNotAuthorized;
